module.exports = __webpack_public_path__ + "files/foucaut.aec338b33dcae2c5cbf077adec46fcdf.pdf";